import { AUTO_LAUNCH_RULES } from "../../config/gameplay";
import type { AutoLaunchTicketSeconds, OrbitForgeSave, ProgressStats } from "../save/types";

export type AutoLaunchUpgradeKind = "duration" | "rate";

export interface AutoLaunchTicketDefinition {
  readonly seconds: AutoLaunchTicketSeconds;
  readonly label: string;
  readonly basePrice: number;
  readonly growth: number;
  readonly unlockLevel: number;
  readonly ticketStat: keyof Pick<ProgressStats, "AutoLaunchTickets60" | "AutoLaunchTickets120" | "AutoLaunchTickets300" | "AutoLaunchTickets600">;
  readonly purchaseStat: keyof Pick<ProgressStats, "AutoLaunchPurchases60" | "AutoLaunchPurchases120" | "AutoLaunchPurchases300" | "AutoLaunchPurchases600">;
}

export interface AutoLaunchUpgradeDefinition {
  readonly kind: AutoLaunchUpgradeKind;
  readonly label: string;
  readonly levelStat: keyof Pick<ProgressStats, "AutoLaunchDurationLevel" | "AutoLaunchRateLevel">;
  readonly unlockLevel: number;
  readonly basePrice: number;
  readonly growth: number;
  readonly maxLevel: number;
}

export const autoLaunchTickets: readonly AutoLaunchTicketDefinition[] = [
  { seconds: 60, label: "60 SEC TICKET", basePrice: 2_200, growth: 1.42, unlockLevel: AUTO_LAUNCH_RULES.unlockLevel, ticketStat: "AutoLaunchTickets60", purchaseStat: "AutoLaunchPurchases60" },
  { seconds: 120, label: "120 SEC TICKET", basePrice: 7_200, growth: 1.46, unlockLevel: AUTO_LAUNCH_RULES.unlockLevel, ticketStat: "AutoLaunchTickets120", purchaseStat: "AutoLaunchPurchases120" },
  { seconds: 300, label: "300 SEC TICKET", basePrice: 21_000, growth: 1.5, unlockLevel: AUTO_LAUNCH_RULES.unlockLevel, ticketStat: "AutoLaunchTickets300", purchaseStat: "AutoLaunchPurchases300" },
  { seconds: 600, label: "10 MIN TICKET", basePrice: 250_000_000, growth: 1.54, unlockLevel: 5, ticketStat: "AutoLaunchTickets600", purchaseStat: "AutoLaunchPurchases600" }
];

export const autoLaunchUpgrades: readonly AutoLaunchUpgradeDefinition[] = [
  { kind: "duration", label: "INCREASED TIME", levelStat: "AutoLaunchDurationLevel", unlockLevel: AUTO_LAUNCH_RULES.durationUpgradeUnlockLevel, basePrice: 3_000_000, growth: 1.54, maxLevel: AUTO_LAUNCH_RULES.maxDurationLevel },
  { kind: "rate", label: "INCREASED RATE", levelStat: "AutoLaunchRateLevel", unlockLevel: AUTO_LAUNCH_RULES.rateUpgradeUnlockLevel, basePrice: 4_250_000, growth: 1.56, maxLevel: AUTO_LAUNCH_RULES.maxRateLevel }
];

export function ticketStorageCount(save: OrbitForgeSave): number {
  return autoLaunchTickets.reduce((sum, ticket) => sum + save.stats[ticket.ticketStat], 0);
}

export function findAutoLaunchTicket(seconds: AutoLaunchTicketSeconds): AutoLaunchTicketDefinition {
  return autoLaunchTickets.find((ticket) => ticket.seconds === seconds)!;
}

export function findAutoLaunchUpgrade(kind: AutoLaunchUpgradeKind): AutoLaunchUpgradeDefinition {
  return autoLaunchUpgrades.find((upgrade) => upgrade.kind === kind)!;
}
